import React from 'react';
import { Grid, Box } from '@mui/material';
import SideBar from '../Stores/Insight/sideBar';
import VideoPage from './videoPage/videoPage';

const Settings = () => {
  return (
    <Box sx={{ flexGrow: 1, height: '100vh', overflow: 'hidden' }}>
      <Grid container spacing={2} sx={{ height: '100%' }}>
        <Grid item xs={12} md={2} sx={{ borderRight: '1px solid #e0e0e0' }}>
          <SideBar />
        </Grid>
        <Grid item xs={12} md={10} sx={{ height: '100%', overflow: 'auto', p: 2 }}>
          <VideoPage />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Settings;
